import "jQuery";

'use strict';

(function($) {
    $(document).ready(function() {
        $('.masonry').each(function() {
            let $wrap = $(this);
            $('.posts-navigation').insertAfter($wrap);
            let masonry_options = {
                itemSelector: '.post',
                transitionDuration: 0
            };
            if($wrap.data('col-w')) {
                masonry_options.columnWidth = $wrap.data('col-w');
            }
            $wrap.masonry(masonry_options);
            setTimeout(function($wrap) {
                $wrap.masonry('layout');
            }, 1000, $wrap);
        });
    });
})( jQuery );